import styled from 'styled-components';

export const Service = styled.div`
    width: 100%;
    margin-bottom: 90px;
    padding: 0 20px;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    @media (min-width: 620px) {
        margin: 0 auto;
        width: 570px;
    }
    @media (min-width: 980px) {
        width: 960px;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
    }
`;
